import type { BoundingBox } from "./models";

// Reference: https://wiki.openstreetmap.org/wiki/Slippy_map_tilenames

const latLngToTile = ({
  lat,
  lng,
  zoom,
}: {
  lat: number;
  lng: number;
  zoom: number;
}) => {
  const n = 2 ** zoom;
  const latRad = (lat * Math.PI) / 180;

  const x = Math.floor(((lng + 180) / 360) * n);
  const y = Math.floor(((1 - Math.asinh(Math.tan(latRad)) / Math.PI) / 2) * n);

  return { x, y };
};

// Function to get all tiles covering a bounding box
export const getTilesForBoundingBox = ({
  corners,
  zoom,
}: {
  corners: { north: number; south: number; east: number; west: number };
  zoom: number;
}) => {
  const { north, south, east, west } = corners;

  // Get tile coordinates for corners
  const topLeft = latLngToTile({ lat: north, lng: west, zoom });
  const bottomRight = latLngToTile({ lat: south, lng: east, zoom });
  const tiles = [];

  // Generate all tiles between the corner coordinates
  for (let x = topLeft.x; x <= bottomRight.x; x++) {
    for (let y = topLeft.y; y <= bottomRight.y; y++) {
      tiles.push({ x, y, z: zoom });
    }
  }

  return tiles;
};

export const convertBoundingBoxToCorners = (boundingBox: BoundingBox) => {
  const sw = boundingBox.getSW();
  const ne = boundingBox.getNE();

  return {
    east: ne.lng,
    north: ne.lat,
    south: sw.lat,
    west: sw.lng,
  };
};
